// src/components/BasicText.tsx
type TextColors = "white" | "faded" | "error";
type TextVariants = "light" | "basic";
type TextSizes = "12px" | "14px" | "16px" | "18px" | "24px" | "30px";

interface BasicTextProps {
  children: React.ReactNode;
  color?: TextColors;
  className?: string;
  variant?: TextVariants;
  size?: TextSizes; // New size prop
}

const variantStyles: Record<TextVariants, string> = {
  light: 'font-extralight',
  basic: 'font-normal',
};

const sizeStyles: Record<TextSizes, string> = {
  "12px": 'text-[12px]',
  "14px": 'text-[14px]',
  "16px": 'text-[16px]',
  "18px": 'text-[18px]',
  "24px": 'text-[24px]',
  "30px": 'text-[30px]',
};

function BasicText({
  children,
  color = "white",
  className = '',
  variant = "light",
  size = "12px", // Default size is 12px
}: BasicTextProps) {
  const fontWeight = variantStyles[variant] || variantStyles.light; // fallback to "light"
  const fontSize = sizeStyles[size] || sizeStyles["12px"]; // fallback to "12px"

  return (
    <div className={`${fontSize} ${fontWeight} 
    ${color === "white" ? 'text-white' : ''}
    ${color === "faded" ? 'text-faded' : ''}
    ${color === "error" ? 'text-red-500' : ''}
    font-geist-mono`}>
      <div className={className}>
        {children}
      </div>
    </div>
  );
}

export default BasicText;
